export default __webpack_public_path__ + "assets/images/watershedSegmentation-31545ab9050de35309356fa96aac25ec.png";